export default __webpack_public_path__ + "static/media/cert-background.d0b9cfc5.jpeg";